export default __webpack_public_path__ + "static/media/2.48654d71.jpg";